import { createStore } from 'vuex'

const store = createStore({
  

})

// export the store
export default store